// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__chlgG","type":"styles_type__2edKE","choices":"styles_choices__IXCBT"};